module.exports = __webpack_public_path__ + "static/media/aim.057fdf4f.png";